// extracted by mini-css-extract-plugin
module.exports = {"modal":"OV","modalContent":"PV","modalOverlay":"QV","copy":"RV","modalBtnContainer":"SV","btnStay":"TV","disabled":"UV","btnContinue":"VV"};